import { Box, Skeleton, Stack } from '@mui/material';
import React from 'react';

const ICON_SIZE = 36;

const IconTitleCardSkeleton: React.FC = () => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      px: 1.5,
      py: 1.25,
    }}
  >
    <Stack direction="row" spacing={1.5} alignItems="center">
      <Skeleton
        variant="circular"
        width={ICON_SIZE}
        height={ICON_SIZE}
        sx={{ flexShrink: 0 }}
      />
      <Stack spacing={0.5} sx={{ minWidth: 0, flex: 1 }}>
        <Skeleton variant="text" width="70%" sx={{ fontSize: '1rem' }} />
        <Skeleton variant="text" width="40%" sx={{ fontSize: '0.75rem' }} />
      </Stack>
    </Stack>
  </Box>
);

export default IconTitleCardSkeleton;
